import { TabList as ReachTabList } from "@reach/tabs";
import { screenSize } from "../../theme";
import styled from "styled-components/macro";

/**
 * Documentation: https://reach.tech/tabs/#tablist
 */
interface ITabListProps {
  width?: string;
  disabled?: boolean;
}
export const TabList = styled(ReachTabList)<ITabListProps>`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.secondaryBorder};
  max-width: ${({ width }) => (width ? width : "fit-content")};
  overflow: auto;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "auto")};
  button {
    opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  }
  @media ${screenSize.mLarge} {
    svg {
      display: none;
    }
  }
`;
